/* eslint-disable jsx-a11y/iframe-has-title */
import React, { useEffect, useState } from "react";
import Menu from "./Menu/menu";
import "./index.css";
import Search from "./Search/search";
import Lists from "./Lists/lists";
import Movie from "./Movie/movie";
import Radio from "./Radio/radio";
import Hot from "./Hot/hot";
import Live from "./Live/live";
import Seek from "./Seek/seek";
import All from "./All/all";
import axios from "axios";
import Real from "./Real/real";

export default function Home() {
  //请求新闻内容
  const [news, setNews] = useState([]);
  const [num, setNum] = useState(1);

  useEffect(() => {
    if (num === 1) {
      axios.get("http://www.itemev.com/home/First").then((response) => {
        setNews(response.data);
      });
    }
    if (num === 2) {
      axios.get("http://www.itemev.com/home/Tiyu").then((response) => {
        setNews(response.data);
      });
    }
    if (num === 3) {
      axios.get("http://www.itemev.com/home/Qiche").then((response) => {
        setNews(response.data);
      });
    }
    if (num === 4) {
      axios.get("http://www.itemev.com/home/Keji").then((response) => {
        setNews(response.data);
      });
    }
    if (num === 5) {
      axios.get("http://www.itemev.com/home/Jiankang").then((response) => {
        setNews(response.data);
      });
    }
    if (num === 6) {
      axios.get("http://www.itemev.com/home/Guonei").then((response) => {
        setNews(response.data);
      });
    }
    if (num === 7) {
      axios.get("http://www.itemev.com/home/Guoji").then((response) => {
        setNews(response.data);
      });
    }
    if (num === 8) {
      axios.get("http://www.itemev.com/home/Wenyu").then((response) => {
        setNews(response.data);
      });
    }
  }, [num]);

  const fixNum = (index) => {
    setNum(index);
  };

  return (
    <div>
      <Menu />
      <Search />
      <Lists />
      <div className="left">
        <Movie />
        <Radio news={news} fixNum={fixNum} />
        <Hot />
        <All news={news} />
        <Live />
        <Seek />
        <Real />
      </div>
    </div>
  );
}
